<script setup lang="ts">
defineProps({
  text: {
    type: String,
    required: true,
  },
});

defineEmits(['click', 'click:close']);
</script>

<template>
  <a
    href="#"
    class="bg-link-block-bg py-0.5 px-1.5 flex justify-between items-center gap-1 rounded-sm"
    @click="$emit('click', $event)"
  >
    {{ text }}

    <button type="button" @click="$emit('click:close', $event)">
      <Icon name="ic:round-close" class="w-4 h-4" />
    </button>
  </a>
</template>
